<template>	   
	<v-container>
	 	<v-card>
	 	 	<v-card-title primary-title>
	 	 		<h3 class="display-1">Bases de datos</h3>
	 	 	</v-card-title>
	 	 	<v-card-text>
	 	 		<v-text-field
	 	 		  name="search" solo
	 	 		  label="Buscar" append-icon="fa fa-search"
	 	 		  id="id"
	 	 		></v-text-field>
				<v-progress-linear :height="5" :active="table.loading" indeterminate></v-progress-linear>
	 	 	 	<v-data-table
	 	 	 	   :headers="table.headers"
	 	 	 	   :items="table.items"
	 	 	 	   :search="table.search"
	 	 	 	   class="elevation-1" v-model="selected"
	 	 	 	   show-select
	 	 	 	   pagination.sync="pagination"
	 	 	 	   item-key="id"
	 	 	 	 >
	 	 	 	   	<template v-slot:item.actions="props">
	 	 	 	   		<td>
	 	 	 	   			<v-btn text color="warning" small fab @click="edit(props.item)"><v-icon>fa fa-pen</v-icon></v-btn>
	 	 	 	   			<v-btn text color="error" small fab @click="confirmDelete(props.item)"><v-icon>fa fa-trash</v-icon></v-btn>
	 	 	 	   		</td>
	 	 	 	   	</template>
	 	 	 	 </v-data-table> 
	 	 	</v-card-text>
	 	 	<v-card-actions>
	 	 	 	<v-btn color="success" @click="create()">Agregar nueva Base de datos</v-btn> 
	 	 	</v-card-actions>
	 	</v-card>
	 	<v-dialog
	 	  v-model="modalCreate.active"
	 	  scrollable persistent
	 	  :overlay="false"
	 	  max-width="900px"
	 	  transition="dialog-transition"
	 	>
 	  	<v-card>
 	  	 	<v-card-title primary-title>
 	  	 	  <h4 class="headline">Crear nuevo Base de datos</h4>
 	  	 	</v-card-title>
 	  	 	<v-card-text>
 	  	 		<v-layout row wrap>
 	  	 		  <v-flex xs8 offset-xs2>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Nombre" solo
	 	  	 	 	    v-model="modalCreate.data.name"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Mascara" solo
	 	  	 	 	    v-model="modalCreate.data.mask"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Descripcion" solo
	 	  	 	 	    v-model="modalCreate.data.description"
	 	  	 	 	  ></v-text-field>
 	  	 		  </v-flex>
 	  	 		</v-layout>
 	  	 		<v-card>
 	  	 		  <v-card-title primary-title>
 	  	 				<h3 class="text-md-center">Tablas</h3>
 	  	 				<v-spacer></v-spacer>
 	  	 				<v-btn color="success" fab small @click="addCTable()"><v-icon>fas fa-plus</v-icon></v-btn>
 	  	 		  </v-card-title>
 	  	 		  <v-card-text>
							<v-layout row wrap>
	  	 	 	    	<v-flex xs12 v-for="(table, index) in modalCreate.data.tables">
	  	 	 	    		<v-layout row wrap>
		  	 	 	    		<v-flex xs3 pa-1>
		  	 	 	    		  <v-text-field
		  	 	 	    		    solo
		  	 	 	    		    label="Nombre"
		  	 	 	    		    v-model="table.name"
		  	 	 	    		  ></v-text-field>
		  	 	 	    		</v-flex>
		  	 	 	    		<v-flex xs3 pa-1>
		  	 	 	    		  <v-text-field
		  	 	 	    		    solo
		  	 	 	    		    label="Mascara"
		  	 	 	    		    v-model="table.mask"
		  	 	 	    		  ></v-text-field>
		  	 	 	    		</v-flex>
		  	 	 	    		<v-flex xs6 pa-1>
										<v-text-field
		  	 	 	    		    solo
		  	 	 	    		    label="descripción"
		  	 	 	    		    v-model="table.description"
		  	 	 	    		    append-icon="fas fa-trash" @click:append="deleteCTable(index)"
		  	 	 	    		  ></v-text-field>	 	 	    		  
		  	 	 	    		</v-flex>
	  	 	 	    		</v-layout>
	  	 	 	      </v-flex>
		  	 	 	  </v-layout>
 	  	 		  </v-card-text>
 	  	 		</v-card>
 	  	 	</v-card-text>
 	  	 	<v-card-actions>
 	  	 	 	<v-btn color="secondary" @click="modalCreate.active = false">Cancelar</v-btn>
 	  	 	 	<v-spacer></v-spacer>
 	  	 	 	<v-btn color="primary" @click="store()">Guardar</v-btn>
 	  	 	</v-card-actions>
 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalEdit.active"
	 	  scrollable persistent
	 	  :overlay="false"
	 	  max-width="900px"
	 	  transition="dialog-transition"
	 	>
	 	  <v-card>
 	  	 	<v-card-title primary-title>
 	  	 	  <h4 class="headline">Editar Base de datos</h4>
 	  	 	</v-card-title>
 	  	 	<v-card-text>
 	  	 		<v-layout row wrap>
 	  	 		  <v-flex xs8 offset-xs2>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Nombre" solo
	 	  	 	 	    v-model="modalEdit.data.name"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Mascara" solo
	 	  	 	 	    v-model="modalEdit.data.mask"
	 	  	 	 	  ></v-text-field>
	 	  	 	 	  <v-text-field
	 	  	 	 	    name="name" required
	 	  	 	 	    label="Descripcion" solo
	 	  	 	 	    v-model="modalEdit.data.description"
	 	  	 	 	  ></v-text-field>
 	  	 		  </v-flex>
 	  	 		</v-layout>
 	  	 		<v-card>
 	  	 		  <v-card-title primary-title>
 	  	 				<h3 class="text-md-center">Tablas</h3>
 	  	 				<v-spacer></v-spacer>
 	  	 				<v-btn color="success" fab small @click="addETable()"><v-icon>fas fa-plus</v-icon></v-btn>
 	  	 		  </v-card-title>
 	  	 		  <v-card-text>
							<v-layout row wrap>
	  	 	 	    	<v-flex xs12 v-for="(table, index) in modalEdit.data.tables">
	  	 	 	    		<v-layout row wrap>
		  	 	 	    		<v-flex xs3 pa-1>
		  	 	 	    		  <v-text-field
		  	 	 	    		    solo
		  	 	 	    		    label="Nombre"
		  	 	 	    		    v-model="table.name"
		  	 	 	    		  ></v-text-field>
		  	 	 	    		</v-flex>
		  	 	 	    		<v-flex xs3 pa-1>
		  	 	 	    		  <v-text-field
		  	 	 	    		    solo
		  	 	 	    		    label="Mascara"
		  	 	 	    		    v-model="table.mask"
		  	 	 	    		  ></v-text-field>
		  	 	 	    		</v-flex>
		  	 	 	    		<v-flex xs6 pa-1>
										<v-text-field
		  	 	 	    		    solo
		  	 	 	    		    label="descripción"
		  	 	 	    		    v-model="table.description"
		  	 	 	    		    append-icon="fas fa-trash" @click:append="deleteETable(index)"
		  	 	 	    		  ></v-text-field>	 	 	    		  
		  	 	 	    		</v-flex>
	  	 	 	    		</v-layout>
	  	 	 	      </v-flex>
		  	 	 	  </v-layout>
 	  	 		  </v-card-text>
 	  	 		</v-card>
 	  	 	</v-card-text>
 	  	 	<v-card-actions>
 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
 	  	 	 	<v-spacer></v-spacer>
 	  	 	 	<v-btn color="primary" @click="update()">Guardar</v-btn>
 	  	 	</v-card-actions>
 	  	</v-card>
	 	</v-dialog>
	 	<v-dialog
	 	  v-model="modalDelete.active"
	 	  scrollable persistent 
	 	  :overlay="false"
	 	  max-width="500px"
	 	  transition="dialog-transition"
	 	>
	 	  	<v-card>
	 	  	 	<v-card-title primary-title>
	 	  	 	  <h4 class="headline">Borrar Punto</h4>
	 	  	 	</v-card-title>
	 	  	 	<v-card-text>
	 	  	 	 	<p>¿ESTA SEGURO DE BORRAR Punto?</p>
	 	  	 	</v-card-text>
	 	  	 	<v-card-actions>
	 	  	 	 	<v-btn color="secondary" @click="modalEdit.active = false">Cancelar</v-btn>
	 	  	 	 	<v-spacer></v-spacer>
	 	  	 	 	<v-btn color="primary" @click="deleteItem()">Confirmar</v-btn>
	 	  	 	</v-card-actions>
	 	  	</v-card>
	 	</v-dialog>
	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.messague }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
/* eslint-disable */
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				createCategory: '',
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL + 'api/plugins/database',
				table: {
					items: [],
					headers: [],
					loading: true,
					search: ''
				},
				modalEdit: {
					active: false,
					data: {
						name: '',
						description: '',
						mask: '',
						tables: []
					}
				},
				modalCreate: {
					active: false,
					data: {
						name: '',
						description: '',
						mask: '',
						tables: []
					}
				},
				modalDelete: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					messague: "",
					color: "success"
				},
				selects: {
					types: [],
					localities: [],
					coor_typ: []
				},
				selected: []
			}
		},
		methods: {
			getData(){
				axios.get(this.baseRoute).then((res) => {
					if(res.data == "Error"){
						this.alert.active = true;
						this.alert.messague = "Impsoble traer los datos";
						this.alert.color = "error";
					}else{
						this.table.items = res.data.items;
						this.table.headers = res.data.headers;
						this.selects = res.data.selects;
					}
					this.table.loading = false
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
					this.table.loading = false;
				});
			},
			create(){
				this.modalCreate.active = true;
				this.modalCreate.data = {
					name: '',
					description: '',
					mask: '',
					tables: []
				};
			},
			store(){
				this.modalCreate.active = false;
				axios.post(this.baseRoute + '/store', this.modalCreate.data).then((res) => {
					if(res.data != "Exito"){
						this.modalCreate.data = {};
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Creado exitosamente";
						this.alert.color = "success";
						this.getData();
					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			edit(item){
				this.modalEdit.active = true;
				this.modalEdit.data = item;
			},
			update(){
				this.modalEdit.active = false;
				axios.put(this.baseRoute + '/update', this.modalEdit.data).then((res) => {
					if(res.data != "Exito"){
						this.modalEdit.data = {};
						this.alert.active = true;
						this.alert.messague = "Los datos suministrados estan incompletos o no son validos";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Actualizado correctamente";
						this.alert.color = "success";					
						this.getData();

					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			confirmDelete(item){
				this.modalDelete.active = true;
				this.modalDelete.data = item;
			},
			deleteItem(){
				this.modalDelete.active = false;
				axios.post(this.baseRoute + '/destroy', this.modalDelete.data).then((res) => {
					if(res.data != "Exito"){
						this.modalDelete.data = {};
						this.alert.active = true;
						this.alert.messague = "Imposible de eliminar";
						this.alert.color = "error";
					}else{
						this.alert.active = true;
						this.alert.messague = "Eliminado correctamente";
						this.alert.color = "error";
						this.getData();
					}	
				}).catch((error) => {
					this.alert.active = true;
					this.alert.messague = "Hubó un error interno en el servidor contacte con el desarrollador";
					this.alert.color = "error";
				});
			},
			addCTable(){
				this.modalCreate.data.tables.push({
					name: '',
					description: '',
					mask:''
				})
			},
			deleteCTable(index){
				console.log(index)
				this.modalCreate.data.tables.splice(index, 1);
			},
			addETable(){
				this.modalEdit.data.tables.push({
					name: '',
					description: '',
					mask:''
				})
			},
			deleteETable(index){
				this.modalEdit.data.tables.splice(index, 1);
			},
		},
		watch: {

		},
		computed: {

		},
	}
/* eslint-enable */
</script>